import React, { useState } from "react";
import DailyActivityHome from "./DailyActivityHome";
import DailyActivityHistory from "./DailyActivityHistory";

const SwitchDailyActivity = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <DailyActivityHome />
          </div>
        );

      case 2:
        return (
          <div>
            <DailyActivityHistory />
          </div>
        );

      default:
        return (
          <div>
            <DailyActivityHome />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-4 sm:p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Today</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">History</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchDailyActivity;
